// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import axios from 'axios'
import ElementUI from 'element-ui'
import { MessageBox } from 'mint-ui'
import 'element-ui/lib/theme-default/index.css'

Vue.use(ElementUI)
Vue.component(MessageBox.name, MessageBox)

Vue.config.productionTip = false
Vue.prototype.$http = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js